import React from 'react';
import {connectWithCore} from 'framework/hocs';
import {rulesMap} from 'go/components/rules/rules';
import {DynamicCheckbox as _DynamicCheckbox} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicCheckbox';

export const DynamicCheckbox = (props) => <_DynamicCheckbox {...props} {...{rulesMap}} />;
export default connectWithCore(DynamicCheckbox);
